import _ from 'lodash';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { updateEditAction } from '@/main/store/actionsFunctions';
import { END_LOADING, ERROR, START_LOADING, START_LOADING_V2, END_LOADING_V2 } from '@/main/store/listEditTypes';
import { createAndSave } from '@/modules/servis/zakazka/services';

import {
	NAME as name,
	DEPENDENT_TABLES as depTableNames,
	CRUMB_LABEL_KEY,
	ZAPUJCKA_STAV,
	PREHLED_DOKLADU,
	PredmetZapujckyEnum,
	POLOZKY,
} from '../constants';
import { apiProvider } from '../api';
import { editActions, editMutations } from './types';

const edit = {
	// Header
	PujcovnaId: null as number | null,
	PujcovnapaNr: null as number | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	VozidlopaId: null as number | null,
	VozidlopaSpz: null as string | null,
	VozidlopaKaroserieNr: null as string | null,
	PujcpaStatus: null as number | null,
	KmStavOdEnabled: false as boolean,
	CanEditStavKm: false as boolean,
	CanRozsiritStav: false as boolean,

	// InformaceProZapujceni
	ZodpovosPrijmeni: null as string | null,
	ZodpovosJmeno: null as string | null,
	ZodpovosTelefon: null as string | null,
	ZodpovosEMail: null as string | null,
	ZakazkaId: null as number | null,
	ZakazkaDruh: null as string | null,
	ZakazkaNr: null as number | null,
	RpNr: null as string | null,
	RpSkupina: null as string | null,
	IdDoklNr: null as string | null,
	Skladost: null as number | null, // not implemented. Is a dependency for OstatnipaId
	OstatnipaId: null as number | null,
	OstatnipaNr: null as string | null,
	OstatnipaText: null as string | null,
	Text: null as string | null,
	Pc: null as number | null,
	DphSzbOzn: null as number | null,
	Sleva: null as number | null,
	PcPevna: null as number | null,
	KmSazba: null as number | null,
	DphSazba: null as number | null, // not implemented, dependency of DphSzbOzn
	VolneKmDen: null as number | null,
	DokladPfx: null as string | null,
	DokladNr: null as number | null,
	DenPlaceno: null as number | null,
	KmVolne: null as number | null,
	KmStavOd: null as number | null,
	PujckaDatOd: null as string | null,
	PalivoStav: null as number | null,
	PredaniMisto: null as string | null,
	PrevzetiMisto: null as string | null,
	PujckapredDatDo: null as Date | null,
	Poplatek: null as number | null,
	DlouhodobPrp: null as boolean | null,
	FaktpristDat: null as Date | null,
	FakturaceDatOd: null as Date | null,
	PracovnikId: null as number | null,
	PracovnikIdText: null as string | null,
	PracovnikOsobniCis: null as string | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	ProvozovnaId: null as number | null,
	ProvozovnaIdText: null as string | null,
	TiskDatPredani: null as Date | null,
	TiskDatPrevzeti: null as Date | null,

	// StavPredPujcenim
	StavpaPred: null as number[] | null,

	// StavPoVraceni
	StavpaPo: null as number[] | null,
	KmStavDo: null as number | null,
	KmPlaceno: null as number | null,
	PujckaDatDo: null as Date | null,
	PalivoOc: null as number | null,
	PalivoMnozstvi: null as number | null,

	// Poznamka
	Podminpa: null as string | null,
	NakladyJdnProvoz: null as number | null,
	PcKatalog: null as number | null,
	NakladyJdn: null as number | null,
	PcProdej: null as number | null,
	VstupPracIdText: null as string | null, // Zadavatel
	VstupDat: null as string | null, // Zalozeno
	EditPracIdText: null as string | null, // Posledni editor
	EditDat: null as string | null, // Datum zmeny

	// PrehledDokladu
	PujcovnapaId: null as number | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Pujcovna: [],
		Skladost: [],
		DphSazba: [],
		Stavpa: [],
	},
	edit,
	localState: {
		VyrobekvozOzn: null as string | null,
		PlanovanaZapujckaExists: null as boolean | null,
		PujcNr: null as string | null,
		VraceniDat: null as string | null,
		VydejkaDat: null as string | null,
		KoPovin: null as boolean | null,
		savedBeforeNajemniSmlouvaPrint: false as boolean,
		CheckResult: null as string | null,
		ZakazkaNrs: null as number[] | null,
		RozsirProtokol: false as boolean,
		RozsireniZakazkaDruh: null as string | null,
		RozsireniZakazkaNr: null as number | null,
		RozsireniZakazkaNrs: null as number[] | null,
		RozsireniZakazkaId: null as number | null,
		printAfterSave: true as boolean,
		selectedPredmetZapujcky: PredmetZapujckyEnum.VOZIDLO,
		tiskDialog: {
			visible: false,
			zakaznikId: null as number | null,
			filter: null as {} | null,
			fetchPdfProvider: null as ((filter: {}) => Promise<any>) | null,
			printDialogClosed: () => {},
		},
	},
	depTableNames,
	depTableSettings: {
		[PREHLED_DOKLADU]: { filter(state) { return { PujcovnapaId: state.edit.PujcovnapaId }; } },
		[POLOZKY]: {
			filter(state) {
				return {
					VozidlopaId: state.edit.VozidlopaId,
					OstatnipaId: state.edit.OstatnipaId,
					FakturaceDatOd: state.edit.FakturaceDatOd,
					FakturaceDatDo: state.edit.FaktpristDat,
				};
			},
		},
	},
	extraActions: {
		async [editActions.ROZSIRENI_PROTOKOLU_CHECK]({ commit, state, dispatch }) {
			const ZapujckaEdit = state.edit;
			try {
				commit(START_LOADING);
				let resp = { data: {} };
				if (ZapujckaEdit.PujcovnapaId) {
					resp = await apiProvider.rozsireniProtokoluCheck({
						PujcovnapaId: ZapujckaEdit.PujcovnapaId,
						PujcpaStatus: ZapujckaEdit.PujcpaStatus,
					});
					await commit(editMutations.ROZSIRENI_PROTOKOLU_CHECK_MUTATION, { data: resp.data });
				}
				return resp;
			} catch (err) {
				dispatch(ERROR, { err }, { root: true });
				return err;
			} finally {
				commit(END_LOADING);
			}
		},
		async [editActions.ROZSIRENI_PROTOKOLU]({ commit, state, dispatch }, answer) {
			const ZapujckaEdit = state.edit;
			try {
				commit(START_LOADING);
				let resp = { data: {} };
				if (ZapujckaEdit.PujcovnapaId) {
					resp = await apiProvider.zapujckaRozsireniProtokolu({
						DlouhodobPrp: ZapujckaEdit.DlouhodobPrp,
						Status: ZapujckaEdit.PujcpaStatus,
						RozsirProtokol: answer,
					});
					await commit(editMutations.ROZSIRENI_PROTOKOLU_MUTATION, { data: resp.data });
				}
				return resp;
			} catch (err) {
				dispatch(ERROR, { err }, { root: true });
				return err;
			} finally {
				commit(END_LOADING);
			}
		},
		[editActions.CREATE_FROM_PLANOVANA_PUJCKA]({ commit, state, dispatch }, planpujcpaId: number) {
			updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.createFromPlanovanaPujcka(planpujcpaId),
			);
		},
		async [editActions.PREDMET_CHANGE]({ commit, state, dispatch }) {
			const ZapujckaEdit = state.edit;
			try {
				commit(START_LOADING);
				let resp = { data: {} };
				if (ZapujckaEdit.OstatnipaId) {
					resp = await apiProvider.predmetChange(ZapujckaEdit);
					commit(editMutations.PREDMET_CHANGED, { data: resp.data });
				}
				return resp;
			} catch (err) {
				dispatch(ERROR, { err }, { root: true });
				return err;
			} finally {
				commit(END_LOADING);
			}
		},
		async [editActions.VOZIDLO_CHANGE]({ commit, state, dispatch }) {
			const ZapujckaEdit = state.edit;
			try {
				commit(START_LOADING);
				let vozidloPujcovnaResp = { data: {} };
				let zmenaVozidlaResp = { data: {} };
				if (ZapujckaEdit.VozidlopaId) {
					vozidloPujcovnaResp = await apiProvider.getVozidloPujcovna(ZapujckaEdit.VozidlopaId);
					zmenaVozidlaResp = await apiProvider.vozidloChange(ZapujckaEdit);
					commit(editMutations.VOZIDLO_CHANGED, { data: vozidloPujcovnaResp.data });
					commit(editMutations.VOZIDLO_CHANGED_ADDITIONAL, { data: zmenaVozidlaResp.data });
				}
				return zmenaVozidlaResp;
			} catch (err) {
				dispatch(ERROR, { err }, { root: true });
				return err;
			} finally {
				commit(END_LOADING);
			}
		},
		async [editActions.ZAKAZNIK_CHANGE]({ commit, state, dispatch }) {
			const ZapujckaEdit = state.edit;
			try {
				commit(START_LOADING);
				let resp = { data: {} };
				if (ZapujckaEdit.ZakaznikId) {
					resp = await apiProvider.zakaznikChange({
						ZakaznikId: ZapujckaEdit.ZakaznikId,
						VozidlopaId: ZapujckaEdit.VozidlopaId,
						DenPlaceno: ZapujckaEdit.DenPlaceno,
						PujcpaStatus: ZapujckaEdit.PujcpaStatus,
					});
					commit(editMutations.ZAKAZNIK_CHANGED, { data: resp.data });
				}
				return resp;
			} catch (err) {
				dispatch(ERROR, { err }, { root: true });
				return err;
			} finally {
				commit(END_LOADING);
			}
		},
		async [editActions.UPDATE_ZAPUJCKU]({ commit, state, dispatch }) {
			try {
				commit(START_LOADING);
				await apiProvider.updateEntity(state.edit.PujcovnapaId!, state.edit);
				if (state.localState.printAfterSave) {
					commit(editMutations.SAVED_BEFORE_NAJEMNI_SMLOUVA_PRINT, true);
				}
			} catch (err) {
				commit(editMutations.SAVED_BEFORE_NAJEMNI_SMLOUVA_PRINT, false);
				dispatch(ERROR, { err }, { root: true });
			} finally {
				commit(END_LOADING);
			}
		},
		// eslint-disable-next-line consistent-return
		async [editActions.CREATE_ZAKAZKA]({ commit, state, dispatch }) {
			try {
				commit(START_LOADING_V2);
				return createAndSave(state);
			} catch (err) {
				dispatch(ERROR, { err }, { root: true });
			} finally {
				commit(END_LOADING_V2);
			}
		},
	},
	extraGetters: {},
	extraMutations: {
		[editMutations.VOZIDLO_CHANGED](state, { data }) {
			state.edit.Pc = data.Pc;
			state.edit.KmSazba = data.KmSazba;
			state.edit.DphSzbOzn = data.DphSzbOzn;
			state.edit.PcPevna = data.PcPevna;
			state.edit.PcKatalog = data.PcKatalog;
			state.edit.PcProdej = data.PcProdej;
			state.edit.Text = data.Text;
			state.edit.KmStavOd = data.KmStav;
			state.edit.NakladyJdn = data.NakladyJdn;
			state.edit.Podminpa = data.Podminpa;
			state.edit.PujcovnaId = data.PujcovnaId;
			state.edit.VolneKmDen = data.VolneKmDen;
			// state.edit.DenPlaceno = data.DenPlaceno; // TODO: nechodi z BE
			state.edit.StrednaklOzn = data.StrednaklOzn;
			state.edit.StrednaklOznText = data.StrednaklOznText;
			state.localState.VyrobekvozOzn = data.VyrobekvozOzn;
		},
		[editMutations.VOZIDLO_CHANGED_ADDITIONAL](state, { data }) {
			state.edit.PracovnikId = data.PracovnikId;
			state.edit.PracovnikIdText = data.PracovnikIdText;
			state.edit.PracovnikOsobniCis = data.PracovnikOsobniCis;
			state.edit.ProvozovnaId = data.ProvozovnaId;
			state.edit.ProvozovnaIdText = data.ProvozovnaIdText;
			if (data.PlanovanaZapujckaExists) {
				state.localState.PlanovanaZapujckaExists = data.PlanovanaZapujckaExists;
				state.localState.PujcNr = data.PujcNr;
				state.localState.VraceniDat = data.VraceniDat;
				state.localState.VydejkaDat = data.VydejkaDat;
			}
			if (data.KmStavOdEnabled !== null) {
				state.edit.KmStavOdEnabled = data.KmStavOdEnabled;
			}
			if (data.KoPovin !== null) {
				state.localState.KoPovin = data.KoPovin;
			}
			if (data.KmSazba !== null) {
				state.edit.KmSazba = data.KmSazba;
			}
			if (data.Pc !== null) {
				state.edit.Pc = data.Pc;
			}
			state.dropdownList.Stavpa = data.DropDownList.Stavpa;
		},
		[editMutations.ZAKAZNIK_CHANGED](state, { data }) {
			if (data.RidicChanged) {
				state.edit.ZodpovosEMail = data.ZodpovosEMail;
				state.edit.ZodpovosJmeno = data.ZodpovosJmeno;
				state.edit.ZodpovosPrijmeni = data.ZodpovosPrijmeni;
				state.edit.ZodpovosTelefon = data.ZodpovosTelefon;
				state.edit.RpNr = data.RpNr;
				state.edit.RpSkupina = data.RpSkupina;
				state.edit.IdDoklNr = data.IdDoklNr;
			}
			if (data.KmStavOdEnabled !== null) {
				state.edit.KmStavOdEnabled = data.KmStavOdEnabled;
			}
			if (data.KoPovin !== null) {
				state.localState.KoPovin = data.KoPovin;
			}
			if (data.KmSazba !== null) {
				state.edit.KmSazba = data.KmSazba;
			}
			if (data.Pc !== null) {
				state.edit.Pc = data.Pc;
			}
		},
		[editMutations.PREDMET_CHANGED](state, { data }) {
			_.assign(state.edit, data);
			state.dropdownList.Stavpa = data.DropDownList.Stavpa;
		},
		[editMutations.ZAPUJCKA_PARTNER_SELECT_MAPPER](state, { data }) {
			state.edit.ZakaznikId = data.value;
			state.edit.ZakaznikIdText = data.text;
		},
		[editMutations.ZAPUJCKA_VOZIDLO_PUJCOVNA_SELECT_MAPPER](state, { data }) {
			state.edit.VozidlopaId = data.id;
			state.edit.VozidlopaSpz = data.rzv;
			state.edit.VozidlopaKaroserieNr = data.vin;
			state.edit.OstatnipaId = null;
			state.edit.OstatnipaNr = null;
			state.edit.OstatnipaText = null;
		},
		[editMutations.ZAPUJCKA_ZAKAZKA_SELECT_MAPPER](state, { data }) {
			state.edit.ZakazkaId = data.value;
			state.edit.ZakazkaDruh = data.text;
		},
		[editMutations.ZAPUJCKA_PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.PracovnikId = data.value;
			state.edit.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.PracovnikOsobniCis = data.osobniCis;
			if (!data.isClear) {
				state.edit.StrednaklOzn = data.strednaklOzn;
				state.edit.StrednaklOznText = data.strednaklOznText;
				state.edit.ProvozovnaId = data.provozovnaId;
				state.edit.ProvozovnaIdText = data.provozovnaIdText;
			}
		},
		[editMutations.ZAPUJCKA_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
				state.edit.ProvozovnaIdText = data.provozovnaIdText;
			}
		},
		[editMutations.ZAPUJCKA_PREDMET_PUJCOVNA_SELECT_MAPPER](state, { data }) {
			state.edit.OstatnipaId = data.value;
			state.edit.OstatnipaNr = data.nr;
			state.edit.OstatnipaText = data.text;
			state.edit.Text = data.text;
			state.edit.VozidlopaId = null;
			state.edit.VozidlopaSpz = null;
			state.edit.VozidlopaKaroserieNr = null;
		},
		[editMutations.ROZSIRENI_PROTOKOLU_CHECK_MUTATION](state, { data }) {
			state.localState.CheckResult = data.CheckResult;
			state.localState.RozsireniZakazkaDruh = data.ZakazkaDruh;
			state.localState.RozsireniZakazkaNr = data.ZakazkaNr;
			state.localState.RozsireniZakazkaNrs = data.ZakazkaNrs;
			state.localState.RozsireniZakazkaId = data.ZakazkaId;
		},
		[editMutations.ROZSIRENI_PROTOKOLU_MUTATION](state, { data }) {
			state.edit.PujcpaStatus! -= 1;
			state.localState.RozsirProtokol = data.RozsirProtokol;
			state.edit.CanEditStavKm = data.CanEditStavKm;
			state.edit.CanRozsiritStav = data.CanRozsiritStav;
		},
		[editMutations.ZAPUJCKA_CHECK_RESULT_RESET](state) {
			state.localState.CheckResult = null;
			state.localState.printAfterSave = true;
		},
		[editMutations.ZAPUJCKA_ROZSIR_PROTOKOL](state) {
			if (state.edit.PujcpaStatus === ZAPUJCKA_STAV.OTEVRENE) {
				state.edit.DokladNr = null;
				state.edit.DokladPfx = null;
				state.edit.KmStavDo = null;
				state.edit.KmPlaceno = 0;
				state.edit.PalivoMnozstvi = 0;
				state.edit.PalivoOc = 0;
				state.edit.PujckaDatDo = null;
				state.edit.TiskDatPredani = null;
			} else if (state.edit.PujcpaStatus === ZAPUJCKA_STAV.PUJCENE || state.edit.PujcpaStatus === ZAPUJCKA_STAV.DLPUJCKA) {
				state.edit.TiskDatPrevzeti = null;
			}
		},
		[editMutations.SAVED_BEFORE_NAJEMNI_SMLOUVA_PRINT](state, saved) {
			state.localState.savedBeforeNajemniSmlouvaPrint = saved;
		},
	},
	props: {
		mode: null,
	},
});
